import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';
import AdminDetail from '../components/admins/AdminDetail';
import ReactsCard from "../components/ui/ReactsCard";
import {useNavigate, useParams} from "react-router-dom";
import {isGuid} from "../utils/function-util";
import {WithOrganization} from "../components/organizations/organization-context";

const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 250,
        margin: theme.spacing(4),
        overflow: 'auto'
    }
}));

const AdminDetails: React.FC<WithOrganization> = ({currentOrganization}) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const navigate = useNavigate();
    const params = useParams<{ adminId: string }>();
    const adminId = isGuid(params.adminId) ? params.adminId : null;
    const title = adminId ? 'Admin.ManageAdminTitle' : 'Admin.AssignAdminTitle';

    const cancelHandler = () => {
        navigate("/admins");
    };

    return (
        <ReactsCard title={t(title)} className={classes.root}>
            <AdminDetail
                         organizationId={currentOrganization.id}
                         adminId={adminId}
                         onCancel={cancelHandler}

            />
        </ReactsCard>
    )
};

export default AdminDetails;
